import { render, staticRenderFns } from "./SelectUnit.vue?vue&type=template&id=2a104a2a"
import script from "./SelectUnit.vue?vue&type=script&lang=ts"
export * from "./SelectUnit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a104a2a')) {
      api.createRecord('2a104a2a', component.options)
    } else {
      api.reload('2a104a2a', component.options)
    }
    module.hot.accept("./SelectUnit.vue?vue&type=template&id=2a104a2a", function () {
      api.rerender('2a104a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/SelectUnit.vue"
export default component.exports